import {Component, inject, OnInit} from '@angular/core';
import {CommonModule, IMAGE_LOADER} from '@angular/common';
import {Event, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {FooterComponent} from './common/footer/footer.component';
import {ThemeCustomizerService} from './common/theme-customizer/theme-customizer.service';
import {awsImageLoader} from "./shared/helpers/image-loader/aws-image-loader";
import {animate, style, transition, trigger} from "@angular/animations";
import {ConsentBannerComponent} from "./common/consent-banner/consent-banner.component";
import {ExternalScriptsService} from "./core/services/external-scripts.service";
import {LoginModalService} from "./shared/helpers/login-modal/login-modal.service";
import {LoginModalComponent} from "./common/login-modal/login-modal.component";
import {RuntimeService} from "./core/services/runtime.service";
import {createLogger} from "./shared/helpers/logger/logger";
import {HeaderStyleOneComponent} from "./common/header-style-one/header-style-one.component";
import {Analytics} from "@angular/fire/analytics";
import {AnalyticsGaService} from "./shared/helpers/analytics/analytics-ga.service";
import {environment} from "../environments/environment";

const logger = createLogger('AppComponent');
export const slideInAnimation =
    trigger('routeAnimations', [
        transition('* <=> *', [
            style({opacity: 0}),
            animate('0.5s', style({opacity: 1})),
        ]),
    ]);

@Component({
    standalone: true,
    selector: 'app-root',
    imports: [
        RouterOutlet,
        CommonModule,
        HeaderStyleOneComponent,
        FooterComponent,
        ConsentBannerComponent,
        LoginModalComponent,
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    providers: [
        {provide: IMAGE_LOADER, useValue: awsImageLoader},
    ],
    animations: [
        slideInAnimation
    ]
})
export class AppComponent implements OnInit {
    title = 'Rooftop';
    isToggled = false;
    showLoginModal = this.loginModalService.showModal;

    private analytics = inject(Analytics);
    readonly #runtimeService = inject(RuntimeService);

    constructor(
        public router: Router,
        public themeService: ThemeCustomizerService,
        private externalScriptsService: ExternalScriptsService,
        private loginModalService: LoginModalService,
        private analyticsGaService: AnalyticsGaService
    ) {
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                // Track page view in Google Analytics
                this.analyticsGaService.trackPageView(event.urlAfterRedirects);
            }
        });
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
        this.showLoginModal = this.loginModalService.showModal;
    }

    ngOnInit(): void {
        if (this.#runtimeService.isBrowser) {
            this.router.events.subscribe((event: Event) => {
                if (event instanceof NavigationEnd) {
                    this.loadExternalScripts();
                }
            });
        }
    }

    private loadExternalScripts(): void {
        // Load Google Tag Manager
        this.externalScriptsService.loadInlineScript(
            `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${environment.gtmId}');`,
            'gtm-inline-script',
            true
        );
        this.externalScriptsService.loadScript('https://www.googletagmanager.com/gtag/js?id=' + environment.firebaseConfig.measurementId, 'ga-script', true);
        this.externalScriptsService.loadNoScript('https://www.googletagmanager.com/ns.html?id=' + environment.gtmId, 'gtm-inline-noscript');
        this.externalScriptsService.loadInlineScript(
            `window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${environment.firebaseConfig.measurementId}', { 'debug_mode': '${environment.debugGa}' });`,
            'gtag-inline-script',
            true
        );

    }
}
